var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutorenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "autorenew"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_147_10137",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    y: 0.125,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_147_10137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "autorenew_2",
    d: "M5.6 16.175C5.23333 15.5417 4.95833 14.8917 4.775 14.225C4.59167 13.5583 4.5 12.875 4.5 12.175C4.5 9.94167 5.275 8.04167 6.825 6.475C8.375 4.90833 10.2667 4.125 12.5 4.125H12.675L11.075 2.525L12.475 1.125L16.475 5.125L12.475 9.125L11.075 7.725L12.675 6.125H12.5C10.8333 6.125 9.41667 6.71233 8.25 7.887C7.08333 9.06233 6.5 10.4917 6.5 12.175C6.5 12.6083 6.55 13.0333 6.65 13.45C6.75 13.8667 6.9 14.275 7.1 14.675L5.6 16.175ZM12.525 23.125L8.525 19.125L12.525 15.125L13.925 16.525L12.325 18.125H12.5C14.1667 18.125 15.5833 17.5377 16.75 16.363C17.9167 15.1877 18.5 13.7583 18.5 12.075C18.5 11.6417 18.45 11.2167 18.35 10.8C18.25 10.3833 18.1 9.975 17.9 9.575L19.4 8.075C19.7667 8.70833 20.0417 9.35833 20.225 10.025C20.4083 10.6917 20.5 11.375 20.5 12.075C20.5 14.3083 19.725 16.2083 18.175 17.775C16.625 19.3417 14.7333 20.125 12.5 20.125H12.325L13.925 21.725L12.525 23.125Z",
    fill: "#B5B8C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorenew);
export default __webpack_public_path__ + "static/media/autorenew.e7d0182f29f930d118a6c7bd8f16a820.svg";
export { ForwardRef as ReactComponent };